// Standard Nostr Event Kinds
export const NOSTR_EVENT_KINDS = {
  TEXT_NOTE: 1,
  POLL: 1068,
  PRIVATE_NOTE: 2044,
} as const;
